import { useState } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://yoybuy.life';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': SITE_URL,
  },
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Что такое Yoybuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yoybuy Spreadsheet — это коллекция тщательно отобранных таблиц с проверенными товарами с китайских маркетплейсов Taobao, Weidian и 1688. Каждая таблица содержит актуальные ссылки, цены, QC-фото и детальные описания товаров для удобных и безопасных покупок.',
      },
    },
    {
      '@type': 'Question',
      name: 'Безопасно ли использовать Yoybuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, абсолютно безопасно. Все таблицы проходят ручную проверку нашей командой. Мы проверяем каждого продавца, качество товаров по QC-фотографиям и актуальность цен. Таблицы обновляются еженедельно.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как заказать товары из таблицы в Россию?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Скопируйте ссылку на товар из Yoybuy Spreadsheet, вставьте её в форму заказа вашего агента по доставке (Yoybuy, Superbuy, Kakobuy и другие), оплатите заказ и дождитесь доставки. Среднее время доставки в Россию — 2-4 недели.',
      },
    },
    {
      '@type': 'Question',
      name: 'Часто ли обновляются таблицы?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Таблицы Yoybuy Spreadsheet обновляются каждую неделю. Мы удаляем неактуальные позиции, добавляем новые находки и обновляем цены, чтобы вы всегда получали лучшие предложения.',
      },
    },
    {
      '@type': 'Question',
      name: 'Какие категории товаров доступны?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'В Yoybuy Spreadsheet представлены 14 категорий: обувь, худи и свитера, футболки, куртки, штаны и шорты, головные уборы, комплекты, нижнее бельё, джерси, аксессуары, сумки, ремни, парфюмерия и многое другое.',
      },
    },
    {
      '@type': 'Question',
      name: 'Бесплатны ли Yoybuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, все базовые таблицы Yoybuy Spreadsheet доступны бесплатно. Мы также предлагаем премиум-таблицы с эксклюзивными находками и расширенными QC-данными для самых требовательных покупателей.',
      },
    },
  ],
};

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const faqs = [
    {
      q: 'Что такое Yoybuy Spreadsheet?',
      a: 'Yoybuy Spreadsheet — это коллекция тщательно отобранных таблиц с проверенными товарами с китайских маркетплейсов Taobao, Weidian и 1688. Каждая таблица содержит актуальные ссылки, цены, QC-фото и детальные описания товаров для удобных и безопасных покупок.',
    },
    {
      q: 'Безопасно ли использовать Yoybuy Spreadsheet?',
      a: 'Да, абсолютно безопасно. Все таблицы проходят ручную проверку нашей командой. Мы проверяем каждого продавца, качество товаров по QC-фотографиям и актуальность цен. Таблицы обновляются еженедельно.',
    },
    {
      q: 'Как заказать товары из таблицы в Россию?',
      a: 'Скопируйте ссылку на товар из Yoybuy Spreadsheet, вставьте её в форму заказа вашего агента по доставке (Yoybuy, Superbuy, Kakobuy и другие), оплатите заказ и дождитесь доставки. Среднее время доставки в Россию — 2-4 недели.',
    },
    {
      q: 'Часто ли обновляются таблицы?',
      a: 'Таблицы Yoybuy Spreadsheet обновляются каждую неделю. Мы удаляем неактуальные позиции, добавляем новые находки и обновляем цены, чтобы вы всегда получали лучшие предложения.',
    },
    {
      q: 'Какие категории товаров доступны?',
      a: 'В Yoybuy Spreadsheet представлены 14 категорий: обувь, худи и свитера, футболки, куртки, штаны и шорты, головные уборы, комплекты, нижнее бельё, джерси, аксессуары, сумки, ремни, парфюмерия и многое другое.',
    },
    {
      q: 'Бесплатны ли Yoybuy Spreadsheet?',
      a: 'Да, все базовые таблицы Yoybuy Spreadsheet доступны бесплатно. Мы также предлагаем премиум-таблицы с эксклюзивными находками и расширенными QC-данными для самых требовательных покупателей.',
    },
  ];

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            FAQ
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Часто задаваемые вопросы
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Ответы на самые популярные вопросы о Yoybuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{faq.q}</span>
                <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 transition-transform duration-200 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}